var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 83,
    viewBox: "0 0 205 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00195312 66.2617V54.7383L33.9473 1.10547H43.5566V17.5117H37.6973L14.8457 53.7227V54.3477H62.2285V66.2617H0.00195312ZM38.166 81.1055V62.7461L38.3223 57.5898V1.10547H51.9941V81.1055H38.166Z",
    fill: "#303A3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.996 82.6289C95.5634 82.6289 90.0426 81.0013 85.4332 77.7461C80.8499 74.4648 77.3212 69.7383 74.8473 63.5664C72.3994 57.3685 71.1754 49.9076 71.1754 41.1836C71.2014 32.4596 72.4384 25.0378 74.8863 18.918C77.3603 12.7721 80.8889 8.08464 85.4723 4.85547C90.0816 1.6263 95.5895 0.0117188 101.996 0.0117188C108.402 0.0117188 113.91 1.6263 118.519 4.85547C123.129 8.08464 126.657 12.7721 129.105 18.918C131.579 25.0638 132.816 32.4857 132.816 41.1836C132.816 49.9336 131.579 57.4076 129.105 63.6055C126.657 69.7773 123.129 74.4909 118.519 77.7461C113.936 81.0013 108.428 82.6289 101.996 82.6289ZM101.996 70.4023C106.996 70.4023 110.941 67.9414 113.832 63.0195C116.748 58.0716 118.207 50.793 118.207 41.1836C118.207 34.8294 117.543 29.4909 116.214 25.168C114.886 20.8451 113.011 17.5898 110.589 15.4023C108.168 13.1888 105.303 12.082 101.996 12.082C97.0218 12.082 93.0895 14.556 90.1988 19.5039C87.3082 24.4258 85.8499 31.6523 85.8238 41.1836C85.7978 47.5638 86.4358 52.9284 87.7379 57.2773C89.066 61.6263 90.941 64.9076 93.3629 67.1211C95.7848 69.3086 98.6624 70.4023 101.996 70.4023Z",
    fill: "#303A3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M142.066 66.2617V54.7383L176.011 1.10547H185.62V17.5117H179.761L156.909 53.7227V54.3477H204.292V66.2617H142.066ZM180.23 81.1055V62.7461L180.386 57.5898V1.10547H194.058V81.1055H180.23Z",
    fill: "#303A3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.43bb2c00107b54b2cfea3227abd7cce9.svg";
export { ForwardRef as ReactComponent };